import React, {
    useCallback, useEffect, useState 
} from 'react'
import { Formik, Form } from 'formik'
import {
    FaArrowRight, FaHospitalAlt, FaArrowLeft, FaPlus 
} from 'react-icons/fa'
import { FiPlus } from 'react-icons/fi'
import { toast } from 'react-toastify'

import Yup from '~/services/yup'
import { api } from '~/services/api'

import {
    Textbox, Button, Select, Checkbox 
} from '~/components/Form'
import ActionFooter from '~/components/ActionFooter'
import Table from '~/components/Table'
import FormEndereco from '~/components/FormEndereco'

import numberUtils from '~/util/number'
import masks from '~/util/masks'
import inputUtils from '~/util/input'

import { Container, AddInstituicao, FormNovoLocal } from './styles'

export default function ({ callback }) {
    const [locais, setlocais] = useState([])
    const [locaisAdicionados, setLocaisAdicionados] = useState([])
    const [cadastroNovo, setCadastroNovo] = useState(false)
    const [initialValues, setInitialValues] = useState({
        local: ''
    })
    const [validation, setValidation] = useState(Yup.object({
        local: Yup.string().required('Forneça o nome do local.')
    }))

    useEffect(() => {
        async function loadLocais() {
            const response = await api.get('instituicao')

            setlocais(response.filter(instituicao => instituicao.id !== 13186 && !['banco', 'micro-empresa'].includes(instituicao.tipo_instituicao.descricao)))
        }

        loadLocais()
    }, [])

    useEffect(() => {
        const storedData = JSON.parse(localStorage.getItem('sindmepa-associacao-temp-data'))

        if(!storedData.locais_trabalho) {
            localStorage.setItem('sindmepa-associacao-temp-data', JSON.stringify({
                ...storedData,
                locais_trabalho: []
            }))
        } else {
            setLocaisAdicionados(storedData.locais_trabalho.map(local => ({
                id: local.id, 
                nome: local.nome,
                icone_correspondencia: local.icone_correspondencia || 'FaTimes',
                iconColor: local.iconColor || '#FFF',
                consultorio: local.consultorio
            })))
        }
    }, [])

    useEffect(() => {
        setInitialValues({ [cadastroNovo ? 'nome' : 'local']: '' })

        setValidation(Yup.object(cadastroNovo ? {
            nome: Yup.string().required('Forneça o nome do local.')
        } : {
            local: Yup.object({
                label: Yup.string(),
                value: Yup.string()
            })
        }))
    }, [cadastroNovo])

    const adicionarInstituicao = useCallback((values, { setSubmitting, resetForm }) => {
        if(!values?.local?.value) {
            setSubmitting(false)
            toast.warn('Selecione a instituição.')
            return
        }

        const { value: id, label: nome } = values.local

        if(!locaisAdicionados.find(local => local.id === id)) {
            const storedData = JSON.parse(localStorage.getItem('sindmepa-associacao-temp-data'))
            storedData.locais_trabalho.push({ nome, id })
            localStorage.setItem('sindmepa-associacao-temp-data', JSON.stringify(storedData))

            setLocaisAdicionados([...locaisAdicionados, { 
                id, 
                nome, 
                icone_correspondencia: 'FaTimes',
                iconColor: '#FFF',
                consultorio: false,
                highlight: true 
            }])
            resetForm()
        } else {
            toast.info('Local já adicionado!')
        }

        setSubmitting(false)
    }, [locaisAdicionados])
    
    function excluirLocal(id) {
        const storedData = JSON.parse(localStorage.getItem('sindmepa-associacao-temp-data'))
        storedData.locais_trabalho = storedData.locais_trabalho.filter(local => local.id !== id)
        localStorage.setItem('sindmepa-associacao-temp-data', JSON.stringify(storedData))

        setLocaisAdicionados(locaisAdicionados.filter(local => local.id !== id))

        return true
    }

    const proximaEtapa = useCallback(() => {
        if(!locaisAdicionados.length) {
            toast.warn('Você deve adicionar pelo menos um local de trabalho.')
            return
        }

        toast.success('Dados salvos! Por favor, continue o preenchimento.')

        callback()
    }, [callback, locaisAdicionados])

    function handleSubmit(values, { resetForm }) {
        const nome = document.querySelector('#nome')
        const correspondencia = document.querySelector('#correspondencia')
        const contato = document.querySelector('#contato')

        values = {
            ...values,
            id: numberUtils.getRandomInt(10000),
            nome: nome.value,
            correspondencia: correspondencia.checked,
            icone_correspondencia: correspondencia.checked ? 'FaCheck' : 'FaTimes',
            iconColor: correspondencia.checked ? '#4caf50' : '#FFF',
            contato: contato.value,
            consultorio: true
        }

        const errorSpans = document.querySelector('.field > input + .error')
        if(errorSpans) {
            errorSpans.remove()
        }

        if(!values.nome) {
            const errorSpan = inputUtils.generateErrorSpan('Defina o nome do consultório.')
            nome.after(errorSpan)
            return
        }

        if(!values.contato) {
            const errorSpan = inputUtils.generateErrorSpan('Preencha o telefone de contato.')
            contato.after(errorSpan)
            return
        }

        while(locaisAdicionados.map(local => local.id === values.id).includes(values.id)) {
            values.id = numberUtils.getRandomInt(10000)
        }

        values.uf = values.uf.value
        values.cidade = values.cidade.value

        const storedData = JSON.parse(localStorage.getItem('sindmepa-associacao-temp-data'))
        storedData.locais_trabalho.push(values)
        localStorage.setItem('sindmepa-associacao-temp-data', JSON.stringify(storedData))

        setLocaisAdicionados([
            ...locaisAdicionados, { 
                ...values,
                highlight: true 
            }
        ])
       
        setCadastroNovo(false)

        resetForm()
        nome.value = ''
        correspondencia.checked = false
        contato.value = ''
    }
    
    return (
        <Container>
            <Formik
                initialValues={initialValues}
                validationSchema={validation}
                onSubmit={adicionarInstituicao}
                enableReinitialize
            >
                {({ isSubmitting, setFieldValue }) => (
                    <Form className="form-inicial-container">
                        <Button className="transparent icon-left" onClick={() => setCadastroNovo(!cadastroNovo)}>
                            {cadastroNovo ? (
                                <>
                                    <FaArrowLeft />
                                    Voltar
                                </>
                            ) : (
                                <>
                                    <FaHospitalAlt />
                                    Cadastrar meu consultório
                                </>
                            )}
                        </Button>

                        <AddInstituicao style={{ display: cadastroNovo ? 'none' : 'flex' }}>
                            <Select 
                                name="local"
                                label="Selecione um local de trabalho"
                                onChange={(selected, actionMeta) => {
                                    setFieldValue(actionMeta.name, selected)

                                    if(selected.value === 0) {
                                        setCadastroNovo(true)
                                    }
                                }}
                                options={[
                                    ...locais.filter(local => !locaisAdicionados
                                        .map(l => l.id)
                                        .includes(local.id))
                                        .map(local => ({
                                            label: `${local.razao_social} ${local.sigla ? `(${local.sigla})` : ''}`,
                                            value: local.id
                                        })),
                                    {
                                        label: 'OUTRO',
                                        value: 0
                                    }
                                ]}
                                containerClass="locais"
                            />

                            <Button type="submit" loading={isSubmitting} className="transparent">
                                Adicionar
                                <FiPlus />
                            </Button>
                        </AddInstituicao>
                    </Form>
                )}
            </Formik>

            <FormNovoLocal style={{ display: cadastroNovo ? 'flex' : 'none' }}>
                <div className="novo-local-identificacao">
                    <Textbox 
                        label="Local" 
                        name="nome" 
                        withoutForm 
                        id="nome" 
                    />

                    <Textbox 
                        label="Telefone fixo"
                        name="contato"
                        id="contato"
                        withoutForm
                        inputMode="numeric"
                        onBlur={() => {
                            const field = document.querySelector('#contato')
                            const { length } = field.value.match(/\d/g)

                            if(length === 11) {
                                field.value = masks.maskApply.mobile(field.value)
                            } else if(length === 10) {
                                field.value = masks.maskApply.phone(field.value)
                            }
                        }}
                    />

                    <Checkbox 
                        label="Quero receber correspondências do Sindmepa em meu consultório"
                        name="correspondencia"
                        id="correspondencia"
                        withoutForm
                    />
                </div>

                <FormEndereco
                    onSubmit={handleSubmit}
                    buttonContent={(
                        <>
                            Cadastrar
                            <FaPlus />
                        </>
                    )}
                    defaultValues={{
                        cep: '',
                        uf: '',
                        cidade: '',
                        bairro: '',
                        rua: '',
                        numero: '',
                        complemento: ''
                    }}
                />
            </FormNovoLocal>

            <Table 
                headers={[
                    { name: 'nome', value: 'Local' }
                ]}
                data={locaisAdicionados.map(local => ({
                    ...local,
                    nome: local.nome
                }))}
                filterable={false}
                handleDelete={excluirLocal}
            />

            <ActionFooter>
                <Button onClick={proximaEtapa} className="white">
                    Continuar
                    <FaArrowRight />
                </Button>
            </ActionFooter>

        </Container>
    )
}
